<template>
  <div>
    <div v-if="curWebsite.type != 1">
      <div class="my-2 bg-white box-radius" :class="type == 2 ? '' : ' p-2'">
        <p @click="handlerLinkLocal('/promoPage')" class="color-blue link-curp"><span
            class="highlight-text-orange">特别提示：</span>本系统所有建设项目<span class="highlight-text-blue">全量底层数据库</span>，均支持<span
            class="highlight-text-blue">建筑企业内部做本地化部署</span>，可搭建企业个性化客户商机实时监测系统平台，并形成可入表的企业数据资产。 详情 >></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      curWebsite: this.$api.getWebsiteType(),
    }
  },
  props: {
    type: { type: Number, default: 1 } //1.默认，2.详情页不需要padding
  },
  methods: {
  },
  mounted() {
  }
}
</script>

<style lang="scss" scoped>
.link-curp {
  cursor: pointer;

  &:hover {
    text-decoration: underline;

  }
}

.color-blue {
  color: #1a5fb4;
}

/* 高亮文字 */
.highlight-text-blue {
  background: linear-gradient(180deg, transparent 60%, rgba(53, 132, 228, 0.15) 60%);
  font-weight: 600;
  color: #1a5fb4;
}

.highlight-text-orange {
  background: linear-gradient(180deg, transparent 60%, rgba(255, 166, 1, 0.15) 60%);
  font-weight: 600;
  color: #ff9900;
}
</style>>